import { render, staticRenderFns } from "./InputGroup.vue?vue&type=template&id=ddd0f256"
import script from "./InputGroup.vue?vue&type=script&lang=js"
export * from "./InputGroup.vue?vue&type=script&lang=js"
import style0 from "./InputGroup.vue?vue&type=style&index=0&id=ddd0f256&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports